export const RenderMixin = {

  /*
   *
   */
  data () {
    return {
      loading: true
    }
  },

  /*
   *
   */
  methods: {

    /*
     *
     */
    rerender () {
      this.loading = true
      this.$nextTick(() => (this.loading = false))
    }  
  }
}
